import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
    PersonFill,
    LockFill,
    ShieldLockFill,
    ArrowClockwise,
    Eye,
    EyeSlash,
} from "react-bootstrap-icons";
import md5 from "md5";
import { config } from "../CommonUtils/CommonURLS";
import axios from "axios";
import { CommonAxiosGet, CommonAxiosPostLogin } from "../CommonUtils/CommonAxios";
import { getTokenExpiry } from "../CommonUtils/TimeUtility";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";
import { broadcastNewLogin } from "../CommonUtils/SessionManager";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";


const Login = () => {

    let navigate = useNavigate();
    const [spinning, setSpinning] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [captcha, setCaptcha] = useState(null);
    const [captchaInput, setCaptchaInput] = useState("");
    const hasFetchedData = useRef(false);

    function GetCaptcha() {
        let url = config.url.STU_URL + `captcha`;
        axios.get(url).then((res) => {
            if (res?.data?.scode === "01") {
                setCaptcha(res?.data?.sdesc);
                setCaptchaInput(res?.data?.captchaId);
            } else {
                setCaptcha("");
                setCaptchaInput("");
            }
        });
    }
    useEffect(() => {
        // clearAuthSession();
        // setModalMode("gos");   
        // setModalMode("pageload")
        // setShowImageModal(true);
        if (!hasFetchedData.current) {
            GetCaptcha();
            hasFetchedData.current = true;
        }
    }, []);
    const formik = useFormik({
        initialValues: {
            userId: "",
            password: "", //NOSONAR
            captcha: "",
        },

        validationSchema: Yup.object({
            userId: Yup.string().required("User ID is required"),
            password: Yup.string().required("Password is required"),
            captcha: Yup.string().required("Captcha is required"),
        }),

        // onSubmit: (values) => {
        //     if (values.captcha.toUpperCase() !== captcha) {
        //         formik.setFieldError("captcha", "Captcha does not match");
        //         reloadCaptcha();
        //         return;
        //     }

        //     console.log(values);
        //     alert("Login Successful");
        // },

        onSubmit: (values, { setSubmitting, setFieldValue }) => {

            const body = {
                userId: values.userId,
                userPassword: md5(values.password.trim()),
                captcha: values.captcha,
                captchaId: captchaInput,
                // loginType,

                // clgType: loginType === "scrutiny" || selectedCourse?.name === "Admin" || selectedCourse?.name === "Inspecttio" ? [] : clgType,
                acYear: "2026-27",
            };

            CommonAxiosPostLogin(config.url.STU_URL + "auth/authenticate", body).then((response) => {

                if (
                    response?.data?.responseCode === "01") {
                    const decodedToken = jwtDecode(response?.data?.accessToken);
                    const tokenExpiry = getTokenExpiry(response.data.accessToken);

                    Cookies.set("token", response?.data?.accessToken);
                    Cookies.set("refreshToken", response?.data?.refreshToken);
                    Cookies.set("tokenTime", tokenExpiry);

                    const accessToken = response.data.accessToken;
                    const refreshToken = response.data.refreshToken;
                    const refreshExpiry = getTokenExpiry(response.data.refreshToken);

                    sessionStorage.setItem("token", response?.data?.accessToken);
                    sessionStorage.setItem("refreshToken", response?.data?.refreshToken);
                    sessionStorage.setItem("tokenTime", tokenExpiry);
                    sessionStorage.setItem("refreshTokenTime", refreshExpiry);

                    sessionStorage?.setItem("Group_Code", decodedToken?.user_gr_code);
                    sessionStorage.setItem("user_id", decodedToken?.user_id);
                    sessionStorage.setItem("is_changed", decodedToken?.is_changed);
                    sessionStorage.setItem("role_id", decodedToken?.role);
                    sessionStorage.setItem("user_name", decodedToken?.empl_first_name);
                    sessionStorage.setItem("Login_Type", decodedToken?.user_desc);
                    broadcastNewLogin();
                    CommonAxiosGet(config.url.STU_URL + "getServices").then((res) => {

                        if (res?.data?.scode === "01") {
                            sessionStorage.setItem("menuData", JSON.stringify(res.data.services));

                            navigate("/Dashboard");

                        }
                    });
                } else {
                    Swal.fire({
                        text: response?.data?.sdesc,
                        icon: "error",
                        confirmButtonText: "OK",
                        backdrop: false,
                    }).then(() => {
                        if (response?.data?.sdesc === "Invalid Captcha") {
                            setFieldValue("captcha", "");
                            GetCaptcha();
                        }
                        if (response?.data?.sdesc === "Invalid login credentials! Try again." || response?.data?.sdesc === "Please Check  type of College") {
                            // setFieldValue("userId", "");
                            // setFieldValue("password", "");
                            // document.getElementById("loginPassword").value = null;
                            // setFieldValue("captcha", "");
                            GetCaptcha();
                        }
                    });
                }
                setSubmitting(false);
            });
        },
    });



    return (
        <form className="kdl-form" onSubmit={formik.handleSubmit} noValidate>
            <div className="kdl-field">
                <label htmlFor="userId">User ID</label>
                <div className={`kdl-input-wrap${formik.touched.userId && formik.errors.userId ? " kdl-input-invalid" : ""}`}>
                    <span className="kdl-input-icon">
                        <PersonFill />
                    </span>
                    <input
                        id="userId"
                        type="text"
                        name="userId"
                        placeholder="Enter User ID"
                        autoComplete="username"
                        value={formik.values.userId}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </div>
                {formik.touched.userId && formik.errors.userId && (
                    <small className="kdl-error">{formik.errors.userId}</small>
                )}
            </div>

            <div className="kdl-field">
                <label htmlFor="password">Password</label>
                <div className={`kdl-input-wrap${formik.touched.password && formik.errors.password ? " kdl-input-invalid" : ""}`}>
                    <span className="kdl-input-icon">
                        <LockFill />
                    </span>
                    <input
                        id="password"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Enter Password"
                        autoComplete="current-password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    <button
                        type="button"
                        className="kdl-eye-btn"
                        onClick={() => setShowPassword((v) => !v)}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                        tabIndex={-1}
                    >
                        {showPassword ? <EyeSlash /> : <Eye />}
                    </button>
                </div>
                {formik.touched.password && formik.errors.password && (
                    <small className="kdl-error">{formik.errors.password}</small>
                )}
            </div>
            <div className="kdl-field">


                <label htmlFor="captcha">Captcha</label>
                <div className="kdl-captcha-row">

                    <div className={`kdl-input-wrap${formik.touched.captcha && formik.errors.captcha ? " kdl-input-invalid" : ""}`}>
                        <span className="kdl-input-icon">
                            <ShieldLockFill />
                        </span>
                        <input
                            id="captcha"
                            type="text"
                            name="captcha"
                            placeholder="Enter Captcha"
                            autoComplete="off"
                            value={formik.values.captcha}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                    {formik.touched.captcha && formik.errors.captcha && (
                        <small className="kdl-error">{formik.errors.captcha}</small>
                    )}
                    <div className="d-flex gap-2">
                        <div className="kdl-captcha-box">
                            <span> {captcha && <img src={captcha} alt="Captcha" width="100%" height="25px" />}</span>


                        </div>
                        <button
                            type="button"
                            className={`kdl-reload-btn${spinning ? " kdl-spin" : ""}`}
                            onClick={GetCaptcha}
                            aria-label="Refresh captcha"
                        >
                            <ArrowClockwise />
                        </button>
                    </div>
                </div>

            </div>

            <button type="submit" className="kdl-submit">
                Login
            </button>
        </form>
    );
};

export default Login;